import { Typography, Stack, Box } from '@mui/material'
import React from 'react'
import HorizontalScrollBar from './HorizontalScrollBar'

import Loader from './Loader'

function SimilarExercises({targetMuscleExercises, equipmentExercises}) {
  return (
    <Box sx={{ mt: {lg: '100px', xs: '0'}}}>
        <Typography variant="h3" mb={4}>Exercises that target the same muscle group</Typography>
        <Stack direction="row" sx={{ p: '2', position: 'relative'}}>
            {targetMuscleExercises.length ? <HorizontalScrollBar data={targetMuscleExercises} /> : <Loader />} 
        </Stack>
        <Typography variant="h3" mb={4}>Exercises that use the same equipment</Typography>
        <Stack direction="row" sx={{ p: '2', position: 'relative'}}>
            {equipmentExercises.length ? <HorizontalScrollBar data={equipmentExercises} /> : <Loader />} 
        </Stack>

    </Box>
  )
}

export default SimilarExercises